import {
  atwAgentsAppOrigin,
  isAtwAgentsPagesPreviewHost,
  isAtwAgentsPublicHost,
  LEGACY_AGENTS_HOST,
} from "@/lib/atwAgentsHost";
import { atwAuthSigninUrl } from "@/lib/atwAuthHost";

export function apiOrigin(): string {
  const fromEnv = import.meta.env.VITE_API_BASE?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  if (typeof window !== "undefined") {
    const h = window.location.hostname.toLowerCase();
    if (isAtwAgentsPagesPreviewHost(h) || (h.endsWith(".pages.dev") && h.includes("atw-agents"))) {
      // Preview and local dev call /api on the host that already resolves.
      // workforce.atw.net is the app people open once that name is attached.
      return `https://${LEGACY_AGENTS_HOST}`;
    }
    if (isAtwAgentsPublicHost(h)) {
      return window.location.origin.replace(/\/$/, "");
    }
  }
  return `https://${LEGACY_AGENTS_HOST}`;
}

export function apiFetchInit(): RequestInit {
  return { credentials: "include" };
}

export function authSignInUrl(callbackPath: string): string {
  const path = callbackPath.startsWith("/") ? callbackPath : `/${callbackPath}`;
  const callback = `${atwAgentsAppOrigin()}${path}`;
  return atwAuthSigninUrl(callback);
}

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${apiOrigin()}${p}`;
}
